module.exports = __webpack_public_path__ + "static/img/vesemir.9fcbae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/vesemir.png
// module id = YoiV
// module chunks = 0